import { render, staticRenderFns } from "./UserSessionStatus.vue?vue&type=template&id=b2bb0b0e&scoped=true&"
import script from "./UserSessionStatus.vue?vue&type=script&lang=js&"
export * from "./UserSessionStatus.vue?vue&type=script&lang=js&"
import style0 from "./UserSessionStatus.vue?vue&type=style&index=0&id=b2bb0b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bb0b0e",
  null
  
)

export default component.exports